import React, {FC, PropsWithChildren} from 'react';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faInfoCircle} from '@fortawesome/free-solid-svg-icons';

import {Bubble} from '@deviceinsight/ng-ui-basic-components';

import './InfoText.less';
import {TranslationDescriptor} from '@deviceinsight/ng-ui-scale-lib/api';

function isTranslationDescriptor(argument: TranslationDescriptor | string): argument is TranslationDescriptor {
	const text = argument as TranslationDescriptor;
	return text.id !== undefined && text.defaultValue !== undefined;
}

type Props = {
	bubble: TranslationDescriptor | string;
	direction?:
		| 'auto-start'
		| 'auto'
		| 'auto-end'
		| 'top-start'
		| 'top'
		| 'top-end'
		| 'right-start'
		| 'right'
		| 'right-end'
		| 'bottom-end'
		| 'bottom'
		| 'bottom-start'
		| 'left-end'
		| 'left'
		| 'left-start';
};

const InfoText: FC<PropsWithChildren<Props>> = ({bubble, children, direction}) => {
	const BubbleContent = (
		<div
			className="info-box"
			style={{
				width: 180
			}}>
			{isTranslationDescriptor(bubble) ? (
				<Trans i18nKey={bubble.id}>{bubble.defaultValue}</Trans>
			) : (
				bubble.toString()
			)}
		</div>
	);
	return (
		<div className="bubble-info-text">
			{children}
			<span className="bubble-wrapper">
				<Bubble
					direction={direction}
					content={BubbleContent}
					style={{
						whiteSpace: 'normal'
					}}
					inverted>
					<FontAwesomeIcon color="#002e48" icon={faInfoCircle} size={'lg'} />
				</Bubble>
			</span>
		</div>
	);
};

export default InfoText;
